export default "__VITE_ASSET__B1rLB7hS__"